import { BookOpen, Code2, FileText, MessageCircle, Video } from 'lucide-react'
import * as React from 'react'

import type { NonFsdsLpMethod } from '@/components/learning-path/non-fsds-learning-path-content'

const iconMap: Record<string, React.ReactNode> = {
  Video: <Video className="size-6" />,
  BookOpen: <BookOpen className="size-6" />,
  Code2: <Code2 className="size-6" />,
  MessageCircle: <MessageCircle className="size-6" />,
  FileText: <FileText className="size-6" />,
}

interface NonFsdsLpOverviewSectionProps {
  title: string
  description: string
  methods: NonFsdsLpMethod[]
}

export default function NonFsdsLpOverviewSection({ title, description, methods }: NonFsdsLpOverviewSectionProps) {
  return (
    <section data-testid="non-fsds-lp-overview-section" className="bg-white px-4 py-14 sm:px-6 sm:py-16 lg:py-20">
      <div className="mx-auto max-w-7xl">
        {/* Header */}
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl md:text-4xl">{title}</h2>
          <p className="mt-3 text-base leading-relaxed text-slate-600 sm:text-lg">{description}</p>
        </div>

        {/* Icon-card grid: 3 cols on desktop, 2+2+1 stacked */}
        <div className="mx-auto mt-10 grid max-w-5xl grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 sm:gap-5 lg:gap-6">
          {methods.map((method, index) => (
            <article
              key={index}
              className="group cursor-default rounded-2xl border border-blue-100/80 bg-gradient-to-b from-blue-50/50 to-white p-6 transition-all duration-200 hover:-translate-y-1 hover:shadow-[0_12px_32px_-12px_rgba(37,99,235,0.2)]"
            >
              {/* Icon circle */}
              <div className="mb-4 flex size-12 items-center justify-center rounded-xl bg-blue-100 text-blue-600 transition-colors duration-200 group-hover:bg-blue-600 group-hover:text-white">
                {iconMap[method.icon] || iconMap.Video}
              </div>
              <h3 className="text-lg font-bold text-slate-900">{method.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{method.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
